import * as yup from 'yup';

import { NAMES } from './DriverLicense.constants';

export const driverLicenseSchema = yup.object().shape({
  [NAMES.PREVIOUS_NUMBER]: yup
    .string()
    .required('Введите номер')
    .matches(/\d{6}/, 'Некорректный номер'),
  [NAMES.PREVIOUS_SERIES]: yup
    .string()
    .required('Введите серию')
    .matches(/\d{2}[а-яА-Я0-9]{2}/, 'Некорректная серия'),
});
